import React from 'react';
import { Provider } from 'react-redux';
import { CacheProvider } from '@emotion/react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import store from './client/store';
import App from './client/App';
import createEmotionCache from './shared/emotionCache';
var emotionCache = createEmotionCache();
hydrate(React.createElement(CacheProvider, { value: emotionCache },
    React.createElement(Provider, { store: store },
        React.createElement(BrowserRouter, null,
            React.createElement(App, null)))), document.getElementById('root'));
if (module.hot) {
    module.hot.accept();
}
